var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.numPages, function(i) {
      return _c("pdf", {
        key: i,
        staticClass: "p-1",
        attrs: { src: _vm.src, page: i }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }